export default __webpack_public_path__ + "static/media/M.32d36022.svg";